import React, { useRef, useState } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { NavLink, Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import "./FooterLatest.scss";
import SendIcon from "@mui/icons-material/Send";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import FacebookIcon from "@mui/icons-material/Facebook";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import InstagramIcon from "@mui/icons-material/Instagram";
import CustomButton from "../custom-button/custom-button";

const FooterLatest = () => {
  const formRef = useRef(null);
  const scriptUrl =
    "https://script.google.com/macros/s/AKfycbyYXjMJo04KCQUdwAQuI4uDdNxjK560XNrwKp7XGE7-Y97TiwJjJRup9h8MIwoMjDlFgw/exec";
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    fetch(scriptUrl, {
      method: "POST",
      body: new FormData(formRef.current),
    })
      .then((res) => {
        alert("SUCCESSFULLY SUBMITTED");
        setLoading(false);
        if (formRef.current) formRef.current.reset();
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  return (
    <footer className="footer-latest-section">
      {/* Top Section */}
      <Row className="footer-top">
        <Col lg={5} md={12} className="brand-section">
          <div className="brand-logo">
            <img
              src="/images/logo/footer-logo-amicus.webp"
              alt="Amicus"
              style={{ maxWidth: "100%" }}
            />
          </div>

          <h5>Get Access To Our Insight</h5>
          <p>Stay in the loop! Sign up for our Newsletter</p>

          <div className="newsletter-input-group">
            <Form
              ref={formRef}
              onSubmit={handleSubmit}
              className="d-flex w-100 relative"
            >
              <Form.Control
                type="email"
                name="Email"
                placeholder="Enter your email"
                aria-label="Enter your email"
                required
              />
              <button className="btn-send" type="submit" disabled={loading}>
                <SendIcon />
              </button>
            </Form>
          </div>
        </Col>

        <Col lg={7} md={12} className="promo-section">
          <h2>
            Expert Guidance for Your
            <br />
            Next Strategic Move
          </h2>
          <p>
            Take the next step with Amicus. Our advisory team is here to help
            you strengthen strategy, enhance governance structures, and build
            financial clarity. Whether you are preparing for growth,
            restructuring, or fundraising, our experts provide the guidance and
            support needed to move forward with confidence.
          </p>
          <CustomButton
            className="btn-view-blogs"
            as={NavLink}
            to="/contact"
            variant="primary"
          >
            Request a Consultation
          </CustomButton>

          {/* <Button as={NavLink} to="/blog" className="btn-view-blogs">
              View All Blogs
              <span className="arrow-circle">
                <ArrowForwardIcon fontSize="small" />
              </span>
            </Button> */}
        </Col>
      </Row>

      {/* Links Section */}
      <Row className="footer-links">
        <Col lg={2} md={4} sm={6} xs={6}>
          <h6>Quick Links</h6>
          <ul>
            <li>
              <NavLink to="/">Home</NavLink>
            </li>
            <li>
              <NavLink to="/company">About Us</NavLink>
            </li>
            <li>
              <NavLink to="/blog">Blogs</NavLink>
            </li>
            <li>
              <NavLink to="/report">Reports</NavLink>
            </li>
            <li>
              <NavLink to="/grow-trees">Sustainability</NavLink>
            </li>
            <li>
              <NavLink to="/contact">Contact Us</NavLink>
            </li>
            <li>
              <NavLink to="/career">Career</NavLink>
            </li>
          </ul>
        </Col>

        <Col lg={4} md={8} sm={12} xs={12} className="services-col">
          <h6>Services</h6>
          <ul className="services-list">
            <li>
              <HashLink smooth to="/services/management-consulting">
                Management Consulting
              </HashLink>
            </li>
            <li>
              <HashLink smooth to="/services/business-diagnostic">
                Business Diagnostic
              </HashLink>
            </li>
            <li>
              <HashLink smooth to="/services/business-transformation">
                Business Transformation
              </HashLink>
            </li>
            <li>
              <HashLink smooth to="/services/cfo-services">
                CFO Services
              </HashLink>
            </li>
            <li>
              <HashLink smooth to="/services/ipo-project-management">
                IPO Project Management
              </HashLink>
            </li>
            <li>
              <HashLink smooth to="/services/startup-advisory">
                Startup Advisory
              </HashLink>
            </li>
            <li>
              <HashLink smooth to="/services/fund-advisory">
                Fund Advisory
              </HashLink>
            </li>
            <li>
              <HashLink
                smooth
                to="/services/project-feasibility-and-strategy-report"
              >
                Project Feasibility & Strategy Report
              </HashLink>
            </li>
            <li>
              <HashLink smooth to="/services/transaction-advisory">
                Transaction Advisory
              </HashLink>
            </li>
            <li>
              <HashLink smooth to="/services/human-capital">
                Human Capital
              </HashLink>
            </li>
          </ul>
        </Col>

        <Col lg={2} md={4} sm={6} xs={6}>
          <h6>Industries</h6>
          <ul>
            <li>
              <NavLink to="/industries/logistics-consulting-advisory">
                Logistics
              </NavLink>
            </li>
            <li>
              <NavLink to="/industries/ecommerce-consulting-advisory">
                Ecommerce
              </NavLink>
            </li>
            <li>
              <NavLink to="/industries/retail-consulting-advisory">
                Retail
              </NavLink>
            </li>
            <li>
              <NavLink to="/industries/manufacturing-consulting-advisory">
                Manufacturing
              </NavLink>
            </li>
            <li>
              <NavLink to="/industries/hospitality-consulting-advisory">
                Hospitality
              </NavLink>
            </li>
            <li>
              <NavLink to="/industries/edtech-consulting-advisory">
                EdTech
              </NavLink>
            </li>
          </ul>
        </Col>

        <Col lg={2} md={6} sm={6} xs={12}>
          <h6>Contact Us</h6>
          <ul className="contact-info">
            <li>
              <span className="label">Address:</span>
              <span className="value">
                1.36 , Gate 2, 74 Techno Park, 91springboard, near Seepz,
                Andheri East, Mumbai, Maharashtra 400093{" "}
              </span>
            </li>
            <li>
              <span className="label">Email:</span>
              <a href="mailto:business@amicusllp.com" className="value">
                business@amicusllp.com
              </a>
            </li>
            <li>
              <span className="label">Phone no:</span>
              <a href="tel:+919820075360" className="value">
                +91-9820075360
              </a>
            </li>
          </ul>
        </Col>

        <Col lg={2} md={6} sm={6} xs={12}>
          <h6>Others</h6>
          <ul>
            <li>
              <NavLink to="/privacy-policy">Privacy Policy</NavLink>
            </li>
            <li>
              <NavLink to="/terms">Terms & Conditions</NavLink>
            </li>
          </ul>
        </Col>
      </Row>

      {/* Bottom Section */}
      <div className="footer-bottom">
        <div className="social-label">Social Links</div>
        <div className="social-icons">
          <a
            href="https://www.linkedin.com/company/amicus-insolvency-turnaround-services-llp/"
            className="social-btn"
            target="_blank"
            rel="noreferrer"
          >
            <LinkedInIcon /> LinkedIn
          </a>
          <a
            href="https://www.facebook.com/AmicusGrowthAdvisors/?paipv=0&eav=AfbVy0HUisgOYqeVZnLZlWZnBJYfraFZdxg8bx7hTcgoveDWeUkxXNsm7dHWBR8YuDI&_rdr"
            className="social-btn"
            target="_blank"
            rel="noreferrer"
          >
            <FacebookIcon /> Facebook
          </a>
          <a
            href="whatsapp://send?text=Hello! I’d like to learn more about what you offer. Can we talk?&phone=+919820075360"
            className="social-btn"
            target="_blank"
            rel="noreferrer"
          >
            <WhatsAppIcon /> Whats app
          </a>
          <a
            href="https://www.instagram.com/amicusgrowthadvisors/?igshid=YmMyMTA2M2Y%3D"
            className="social-btn"
            target="_blank"
            rel="noreferrer"
          >
            <InstagramIcon /> Instagram
          </a>
        </div>
      </div>
    </footer>
  );
};

export default FooterLatest;
